export class VehicleReportModel {

  reportUid: number;
  vehicleUid: number;
  clientUid: number;
  organisationUid: number;
  mileage: string;
  tyres: string;
  lights: string;
  oil: string;
  hydrualics: string;
  handbrake: string;
  workPlatform: string;
  guardRails: string;
  boomInterlock: string;
  stabiliser: string;
  switchFunction: string;
  emergencyPump: string;
  fullBoomRange: string;
  boomLimit: string;
  enginerOperation: string;
  lolerCert: string;
  other: string;
  userEmail: string;
  dateTime: string;
  otherIssue: string = "NA";

  constructor() {

  }
}